import { createContext, useContext, useState, useCallback, useLayoutEffect } from "react";

const DarkModeContext = createContext();

function readStoredDarkMode() {
  if (typeof window === "undefined") return false;
  try {
    return localStorage.getItem("darkMode") === "true";
  } catch {
    return false;
  }
}

export function DarkModeProvider({ children }) {
  const [isDarkMode, setIsDarkMode] = useState(readStoredDarkMode);

  const applyDarkClass = useCallback((next) => {
    document.documentElement.classList.toggle("dark-mode", next);
    const tc = document.querySelector('meta[name="theme-color"]');
    if (tc) tc.setAttribute("content", next ? "#1a1a1a" : "#fffbf5");
  }, []);

  useLayoutEffect(() => {
    applyDarkClass(isDarkMode);
  }, [isDarkMode, applyDarkClass]);

  const toggleDarkMode = useCallback(() => {
    setIsDarkMode((prev) => {
      const next = !prev;
      try {
        localStorage.setItem("darkMode", String(next));
      } catch {
        /* ignore */
      }
      applyDarkClass(next);
      return next;
    });
  }, [applyDarkClass]);

  return (
    <DarkModeContext.Provider value={{ isDarkMode, toggleDarkMode }}>
      {children}
    </DarkModeContext.Provider>
  );
}

export const useDarkMode = () => useContext(DarkModeContext);
